// Meta keeps older API versions working for a long time and v22.0 is current (10.03.26).
export const META_API_VERSION = "v22.0";

export const META_CONVERSION_API_EVENTS = {
  PURCHASE: "Purchase",
} as const;

// Meta conversions API
export const META_PIXEL_ID = process.env.META_PIXEL_ID as string;
export const META_ACCESS_TOKEN = process.env.META_ACCESS_TOKEN as string;
